import { MPCIGridRow } from "../typings/iGridRow";
import { MPCEventBus } from "../../helpers/event-bus";
import { MPCDeviceDetectionHelper } from "../../helpers/deviceDetectionHelper";
import { MPCGridController } from "../grid-controller";
const ArrowUpIcon = require("../../../images/arrow-up.svg") as string;
const Checkbox = require("../../../images/checkbox.svg") as string;

export module MPCControlsRow {
    import IGridRow = MPCIGridRow.IGridRow;
    import EventBus = MPCEventBus.EventBus;
    import DeviceDetectionHelper = MPCDeviceDetectionHelper.DeviceDetectionHelper;
    import GridController = MPCGridController.GridController;

    export class ControlsRow {
        private readonly overlayDelay: number = 1000;

        private gridRowsArray: Array<IGridRow>;
        private collapseAll: boolean;
        private identicalPropertiesHidden: boolean;
        private eventBus: EventBus;
        private deviceDetectionHelper: DeviceDetectionHelper;
        private arrowUp: HTMLElement;
        private filterOnlyDifferencesBtn: HTMLElement;
        private filterOnlyDifferencesCheckBox: HTMLElement;
        private collapseAllTitle: HTMLElement;
        private expandAllTitle: HTMLElement;
        private gridController: GridController;
        private overlay: HTMLElement;
        private collapseAllBtn: HTMLElement
        private firstColumnHeader: HTMLElement;

        public init(controlsRow: HTMLElement, gridRowsArray: Array<IGridRow>, emptyColumnsAmount: number,
            gridController: GridController, firstColumnHeader: HTMLElement): void {
            this.gridRowsArray = gridRowsArray;
            this.gridController = gridController;
            this.firstColumnHeader = firstColumnHeader;
            this.collapseAll = true;
            this.eventBus = MPCEventBus.EventBus.instance;
            this.deviceDetectionHelper = MPCDeviceDetectionHelper.DeviceDetectionHelper.instance;
            this.eventBus.subscribe('filter-row.is-expanded', (oneRowExpanded: boolean) => { this.updateCollapseAllButtonState(oneRowExpanded) });
            this.filterOnlyDifferencesBtn = controlsRow.querySelector('.filter-only-differences');
            this.filterOnlyDifferencesCheckBox = this.filterOnlyDifferencesBtn.querySelector('.only-diff-chb');
            this.filterOnlyDifferencesCheckBox.innerHTML = Checkbox;

            this.overlay = gridController.gridHtmlElement().querySelector('.mpc-loading-overlay');

            this.collapseAllBtn = controlsRow.querySelector('.collapse-all');
            this.arrowUp = this.collapseAllBtn.querySelector('.mpc-arrow-up');
            this.arrowUp.innerHTML = ArrowUpIcon;

            this.collapseAllTitle = this.collapseAllBtn.querySelector('.collapse-all-title');
            this.expandAllTitle = this.collapseAllBtn.querySelector('.expand-all-title');
            this.collapseAllBtn.addEventListener('click', () => { this.handleCollapseAllClick(); });
            this.collapseAllBtn.addEventListener('keydown', (event: any) => {
                // prevent page jump down on Space btn., click
                if (event.code === 'Space')
                    event.preventDefault(); 
            });

            this.filterOnlyDifferencesBtn.addEventListener('keydown', (event: any) => {
                // prevent page jump down on Space btn., click
                if (event.code === 'Space')
                    event.preventDefault(); 
            });

            this.disableControlButtons(emptyColumnsAmount);
        }

        private disableControlButtons(emptyColumnsAmount: number): void {
            if (emptyColumnsAmount >= 3) {
                this.filterOnlyDifferencesBtn.classList.add('disable-diff-btn');
                this.filterOnlyDifferencesCheckBox.classList.add('disable-diff-chb');

                // expand collapse button should be disabled only there is no articles in comparison list:
                if (emptyColumnsAmount === 4 )
                    this.collapseAllBtn.classList.add('disable-hide-all-btn');
            }
            else {
                // Check does the all grid rows has the same values:
                let allRowValuesAreEqual: boolean = true;
                for (const gridRow of this.gridRowsArray) {
                    if (!gridRow.getRowValuesAreEqual()) {
                        allRowValuesAreEqual = false;
                        break;
                    }
                }    

                if (allRowValuesAreEqual) {
                    this.filterOnlyDifferencesBtn.classList.add('disable-diff-btn');
                    this.filterOnlyDifferencesCheckBox.classList.add('disable-diff-chb');
                }
                else {
                    this.filterOnlyDifferencesBtn.addEventListener('click', () => { 
                       // this.calculateOverlayHeight(); 
                        this.handleFilterOnlyDifferencesBtnClick(); 
                    });
                }
            }
        }

        private handleCollapseAllClick(): void {
            const isSlowBrowser: boolean = this.deviceDetectionHelper.isMicrosoftBrowser();
            this.arrowUp.classList.toggle('rotate-arrow');
            this.collapseAllTitle.classList.toggle('show');
            this.expandAllTitle.classList.toggle('show');

            for (const gridRow of this.gridRowsArray) {
                gridRow.triggerCollapseExpandRow(this.collapseAll, isSlowBrowser);
            }

            this.collapseAll = !this.collapseAll;
        }

        async handleFilterOnlyDifferencesBtnClick() {
            if (this.identicalPropertiesHidden) {
                this.filterOnlyDifferencesCheckBox.classList.remove('only-diff-chb-checked');
            } else {
                this.filterOnlyDifferencesCheckBox.classList.add('only-diff-chb-checked');
            }

            this.loadingSpinner(true);
            const hidingFinished = await this.hideIdenticalProperties();

            if (hidingFinished) {
                this.gridController.setFirstAndLastClass();
                this.loadingSpinner(false);
            }
        }

        private loadingSpinner(open: boolean): void {
            if (open) {
                this.overlay.classList.add('open');
            } else {
                setTimeout(() => { this.overlay.classList.remove('open'); }, this.overlayDelay);
            }
        }

        private hideIdenticalProperties() {
            return new Promise(it => {
                if (this.identicalPropertiesHidden) {
                    // otherwise show all rows:
                    for (const gridRow of this.gridRowsArray) {
                        gridRow.showOnlyDifferences(false);
                    }

                    this.identicalPropertiesHidden = false;
                }
                else {
                    // hide rows with same values if checkbox checked:
                    for (const gridRow of this.gridRowsArray) {
                        gridRow.showOnlyDifferences(true);
                    }

                    this.identicalPropertiesHidden = true;
                }

                it('true')
            });
        }

        private updateCollapseAllButtonState(oneRowExpanded: boolean): void {
            // if all filter rows are collapsed and later one of the was expanded by customer.
            // Button expand all should return to previous state hide all.

            if (oneRowExpanded) {
                this.arrowUp.classList.remove('rotate-arrow');
                this.collapseAllTitle.classList.add('show');
                this.expandAllTitle.classList.remove('show');
                this.collapseAll = oneRowExpanded;
            }
        }
    }
}